/** Feature-local TanStack QueryClient per admin-servizi (F-009.6). */
import { QueryClient } from '@tanstack/react-query';

export function createServiziQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
      mutations: { retry: 0 },
    },
  });
}

export const serviziQueryClient = createServiziQueryClient();
export const serviziQueryKey = ['admin', 'servizi'] as const;
